export default __webpack_public_path__ + "static/media/SansTimesSans@16R.7f527910.ttf";